import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = { class: "tr" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "被执行人", -1)
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "立案时间", -1)
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "tr" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "案号", -1)
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "执行法院", -1)
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "tr" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "执行标的", -1)
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "item" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "身份证号码/组织架构代码", -1)
const _hoisted_22 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.d.name || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.toDate(_ctx.d.liandate,"YYYY-MM-DD")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.d.anno || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.d.executeGov || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.d.biaodi?_ctx.d.biaodi+'元':'-'), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.d.partyCardNum || '-'), 1)
      ])
    ])
  ], 512)), [
    [_directive_loading, _ctx.loading]
  ])
}